import { render, staticRenderFns } from "./HomeHeader.vue?vue&type=template&id=bc4ccf50&scoped=true&"
import script from "./HomeHeader.vue?vue&type=script&lang=ts&"
export * from "./HomeHeader.vue?vue&type=script&lang=ts&"
import style0 from "./HomeHeader.vue?vue&type=style&index=0&id=bc4ccf50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4ccf50",
  null
  
)

export default component.exports